import { render, staticRenderFns } from "./TransportEditDialog.vue?vue&type=template&id=9b83465a"
import script from "./TransportEditDialog.vue?vue&type=script&lang=ts"
export * from "./TransportEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports